import './App.css';
import './styles/global.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import UnlockPage from "./pages/UnlockPage";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Contact from "./pages/Contact";
import CartPage from "./pages/CartPage";
import ShopLater from './pages/ShopLater';
import ProductDetails from "./pages/ProductDetails";
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmation from './pages/OrderConfirmation';
import NotFound from './pages/NotFound';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { CartProvider } from "./CartContext";
import supabase from "./config/supabaseClient";
import ProtectedRoute from './components/ProtectedRoute';

// PayPal Client ID
const PAYPAL_CLIENT_ID = "ASLpP_pw_YV4PcsAgwe0wGZhYkKbdXXwzcLAWireDj8Bvex1Qfj-7wga9aqLHdBaN3kIiaxNk9HRMgzG";

function App() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: productData, error } = await supabase
          .from("products")
          .select("*");

        if (error) {
          throw error;
        }

        setProducts(productData);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <PayPalScriptProvider options={{ "client-id": PAYPAL_CLIENT_ID, "currency": "USD" }}>
      <CartProvider>
        <Router>
          <AppContent products={products} loading={loading} />
        </Router>
      </CartProvider>
    </PayPalScriptProvider>
  );
}

const AppContent = ({ products, loading }) => {
  const location = useLocation();

  return (
    <Routes>
      {/* 🔹 Unlock Page - Always Accessible */}
      <Route path="/" element={<UnlockPage />} />

      {/* 🔹 Protected Pages - Accessible ONLY after unlocking */}
      <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
      <Route path="/products/:categoryId" element={<ProtectedRoute><Products /></ProtectedRoute>} />
      <Route path="/about" element={<ProtectedRoute><About /></ProtectedRoute>} />
      <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
      <Route path="/cart" element={<ProtectedRoute><CartPage /></ProtectedRoute>} />
      <Route path='/shop-later' element={<ProtectedRoute><ShopLater /></ProtectedRoute>} />
      <Route path="/product/:id/:variant" element={<ProtectedRoute><ProductDetails products={products} loading={loading} /></ProtectedRoute>} />

      {/* 🔹 Restricted Pages - Redirect to Cart if accessed via URL */}
      <Route path="/checkout" element={<ProtectedRoute restricted><CheckoutPage /></ProtectedRoute>} />
      <Route path="/order-confirmation" element={<ProtectedRoute restricted><OrderConfirmation /></ProtectedRoute>} />

      <Route path="*" element={<NotFound />} />
    </Routes>

  );
};

export default App;
